export default __webpack_public_path__ + "static/media/eye-regular.51334bdc.svg";